import { render } from "./AnswerArea.vue?vue&type=template&id=734b932e&scoped=true"
import script from "./AnswerArea.vue?vue&type=script&lang=js"
export * from "./AnswerArea.vue?vue&type=script&lang=js"

import "./AnswerArea.vue?vue&type=style&index=0&id=734b932e&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734b932e"]])

export default __exports__